import { RootState } from "../../../../ReduxToolkit/Store";

export const selectCenterListLoading = (state: RootState) =>
  state.centerList.loading;

export const selectCenterListError = (state: RootState) =>
  state.centerList.error;

export const selectCenterListInfo = (state: RootState) => state.centerList.data;

export const selectDepartmentListLoading = (state: RootState) =>
  state.departmentList.loading;

export const selectDepartmentListError = (state: RootState) =>
  state.departmentList.error;

export const selectDepartmentListInfo = (state: RootState) =>
  state.departmentList.data;

export const selectSubDepartmentListLoading = (state: RootState) =>
  state.subDepartmentListDetailsSlice.loading;

export const selectSubDepartmentListError = (state: RootState) =>
  state.subDepartmentListDetailsSlice.error;

export const selectSubDepartmentListInfo = (state: RootState) =>
  state.subDepartmentListDetailsSlice.data;

export const selectEmployeePrimaryTabActive = (state: RootState) =>
  state.employeeManagement.employeePrimaryTabActive;

export const selectEmployeeSecondaryTabActive = (state: RootState) =>
  state.employeeManagement.employeeSecondaryTabActive;
